import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 18,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icons Small/Arrow right",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.493 9.00005L3.99969 16.5067C3.97611 16.5297 3.95736 16.5572 3.94456 16.5875C3.93177 16.6179 3.92517 16.6504 3.92517 16.6834C3.92517 16.7163 3.93177 16.7489 3.94456 16.7793C3.95736 16.8096 3.97611 16.8371 3.99969 16.86C4.02268 16.8836 4.05015 16.9024 4.08049 16.9152C4.11083 16.928 4.14343 16.9346 4.17636 16.9346C4.20929 16.9346 4.24189 16.928 4.27223 16.9152C4.30257 16.9024 4.33005 16.8836 4.35303 16.86L11.9997 9.18005C12.0233 9.15707 12.042 9.12959 12.0548 9.09925C12.0676 9.06891 12.0742 9.03631 12.0742 9.00338C12.0742 8.97045 12.0676 8.93785 12.0548 8.90751C12.042 8.87717 12.0233 8.8497 11.9997 8.82671L4.3397 1.14671C4.31673 1.12227 4.28876 1.10307 4.2577 1.09041C4.22663 1.07776 4.19321 1.07195 4.1597 1.07338C4.12724 1.07248 4.09496 1.07856 4.06506 1.09121C4.03515 1.10386 4.00832 1.12279 3.98636 1.14671C3.96278 1.1697 3.94403 1.19717 3.93123 1.22751C3.91843 1.25785 3.91184 1.29045 3.91184 1.32338C3.91184 1.35631 3.91843 1.38891 3.93123 1.41925C3.94403 1.44959 3.96278 1.47707 3.98636 1.50005L11.493 9.00005Z",
			fill: "#303651",
			stroke: "#303651"
		})
	})
});
export default SvgIconArrowRight;
